/** ACT004 问答答题结果提示文案（与「请先完成本题」一致：uni.showToast → Vant Toast） */
export const ACT004_QUIZ_CORRECT_ANSWER_MSG = '回答正确'
export const ACT004_QUIZ_WRONG_ANSWER_MSG = '回答错误'
export const ACT004_QUIZ_ALREADY_CORRECT_MSG = '您已经回答正确'

const QUIZ_FEEDBACK_TOAST_MS = 2000

function showQuizFeedbackToast(title, opts) {
  const text = String(title || '提示').trim()
  const duration =
    opts && opts.duration != null ? Number(opts.duration) : QUIZ_FEEDBACK_TOAST_MS
  const blocking = !(opts && opts.blocking === false)

  if (typeof uni !== 'undefined' && typeof uni.showToast === 'function') {
    uni.showToast({
      title: text,
      icon: 'none',
      duration,
      className: 'act004-quiz-feedback-toast'
    })
    if (!blocking) return Promise.resolve()
    return new Promise((resolve) => {
      setTimeout(resolve, duration)
    })
  }
  return Promise.resolve()
}

/** 答对提示（含最后一题通过） */
export function showAct004QuizCorrectAnswerModal() {
  return showQuizFeedbackToast(ACT004_QUIZ_CORRECT_ANSWER_MSG)
}

/** 答错提示（不阻塞选项点击，便于立即重选） */
export function showAct004QuizWrongAnswerModal() {
  return showQuizFeedbackToast(ACT004_QUIZ_WRONG_ANSWER_MSG, { blocking: false })
}

/** 点击即提交：本题已答对后再次点选项 */
export function showAct004QuizAlreadyCorrectToast() {
  return showQuizFeedbackToast(ACT004_QUIZ_ALREADY_CORRECT_MSG, { blocking: false })
}
